<template>
  <div class="main-wrapper" :class="{ 'is-mobile': isMobile }">
    <ClientOnly>
      <AlertUpdateMessage />
      <UpdateMessage />
    </ClientOnly>
    <div
      class="exposed overflow-y-auto overflow-x-auto"
      :style="{
        height: `calc(100vh - ${topHeight}px)`,
        backgroundImage: `url(${transformImage(
          getFeUrl(
            `/youyan-platform/png/${
              getEnv('area') === 'CN' ? 'white' : 'black2'
            }.png`
          )
        )})`,
      }"
    >
      <ClientOnly v-if="account?.user_id">
        <AlertMessages />
        <NotificationMessages />
      </ClientOnly>
      <ClientOnly>
        <Compatibility />
      </ClientOnly>
      <slot />
    </div>
    <div v-if="!isMobile" ref="topRef">
      <Top></Top>
    </div>
    <Account />
    <VideoDownload />
    <ClientOnly>
      <TemplateModal />
    </ClientOnly>
    <PublishProcess />
    <TasteAccountHint v-model:open="showCreateModal" :accounts="accountList" />
    <FloatComps v-if="!isMobile" />
    <r-gdpr-cookie-consent v-if="!isChinese()" />
  </div>
</template>
<script lang="ts" setup>
import { AlertMessages, NotificationMessages } from '@youyan/common'
import Top from '../components/xTop/index.vue'
import Account from '@/features/account/index.vue'
import VideoDownload from '@/features/videoDownload/index.vue'
import PublishProcess from '@/features/publish/index.vue'
import { AlertUpdateMessage } from '@/features/alert/topAlertUpdateMessage'
import Compatibility from '~/components/compatibility/index.vue'
import TemplateModal from '~/features/template/components/modal.vue'
import TasteAccountHint from '~/features/tasteAccountHint/index.vue'
import FloatComps from '@/features/floatComps/index.vue'

const topRef = ref()

const topHeight = ref(0)

const account = useSession()

const showCreateModal = useCheckCreate()
const accountList = useAccountList()
const { isMobile } = useDevice()

useResizeObserver(topRef, (entries) => {
  const entry = entries[0]
  const { height } = entry.contentRect
  topHeight.value = height + 56
})
</script>
<style lang="scss" scoped>
.exposed {
  @apply flex flex-col bg-back-bg;
  // :deep(> div:not(.ant-alert)) {
  //   @apply flex flex-col bg-back-bg;
  // }
}
</style>
